import { UserInformation } from "../store/user/types";
import CookiesKeys, { cookieStorage } from "./cookies";

export const getToken = (): string | null => {
  return localStorage.getItem(CookiesKeys.TokenKey);
};

export const login = (token: string) => {
  localStorage.setItem(CookiesKeys.TokenKey, token);
};



export const getTokenCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.TokenKey);
};

export const loginCookie = (token: string) => {
  cookieStorage.setItem(CookiesKeys.TokenKey, token);
};
export const credentialsCookie = (id: string,user:string,password:string) => {
  cookieStorage.setItem(CookiesKeys.Id, id);
  cookieStorage.setItem(CookiesKeys.User, user);
};

export const tenantCookie = (id: string,) => {
  cookieStorage.setItem(CookiesKeys.Tenant, id);
};
export const getIdCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Id);
};
export const getTenantCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Tenant);
};
export const getUserCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.User);
};

export const removeloginCookie = () => {
  cookieStorage.removeItem(CookiesKeys.TokenKey);
};


export const modulesCookie = (id: string,) => {
  cookieStorage.setItem(CookiesKeys.Modules, id);
};
export const rolCookie = (id: string,) => {
  cookieStorage.setItem(CookiesKeys.Rol, id);
};
export const getModulesCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Modules);
};
export const getRolCookie = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.Rol);
};
export const logout = (redirectTo?: string) => {
  localStorage.removeItem(CookiesKeys.TokenKey);
  removeloginCookie();
  cookieStorage.removeItem(CookiesKeys.ActivePortalSession);

  if (typeof redirectTo === "string" && redirectTo) {
    window.location.replace(redirectTo);
    return;
  }

  window.location.reload();
};
export const setValidationMainModules = (validate: string) => {
  cookieStorage.setItem(CookiesKeys.MainModules, validate);
};

export const isAuthenticated = () => {  
  const accessToken = cookieStorage.getItem("tokenKey");
  if(accessToken){
    return true;
  }
  return false;
};
export const getValidationMainModules = (): string | null => {
  return cookieStorage.getItem(CookiesKeys.MainModules);
};